export class greviencemodel {
  "grievanceTypeId"			    : number;
  "grievanceSubTypeId"			: number;
  "grievanceTitleId"			   : number;
  "grievanceTypeName"			   : string = "";
  "grievanceSubTypeName"			: string = "";
  "grievanceTitleName"			: string = "";
  "consumerNumber"        : string = "";
  "grievanceNarration"     :string="";
  "complainTitle"         : string = "";
  "mobileNo"              : number;
  "eTokenNo"              : string="";
  "status"               : string="";
  "selectedOption"       : number;
  "consumerOTP"             : string = "";
  "emailId"              : string = "";
  "emailOTP"            :  number;
  "mobileNumber" : number;
  "mobileOtp":number;
  "catagoryType" : string;
  "name1"       : string;
  "name2"             : string = "";
  "careOf"              : string = "";
  "street2" : string;
  "street3" : string;
  "location"       : string;
  "city1"             : string = "";
  "post_code"              : number;
  "city2" : string;

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/grevience/grevience.model.ts